import { createContext } from 'react';

import { UserLoginState } from './types/supabase-types';

export const AuthContext = createContext<UserLoginState>({ loggedIn: false, session: null });
